
export default [
    {
        id: "Dashboard",
        title: "Dashboard",
        navLink: "/dashboard",
    },
    {
        id: "OrderManagement",
        title: "Order Management",
        navLink: "/ordermanagement",
        children: [
            {
                id: "Orders",
                title: "Orders",
                navLink: "/ordermanagement/orders",
            },
            {
                id: "OrderFulfillment",
                title: "Order Fulfillment",
                navLink: "/ordermanagement/orderfulfillment",
            },
            {
                id: "ReturnsRefunds ",
                title: "Returns & Refunds ",
                navLink: "/ordermanagement/returns",
            },
        ]
    },
    {
        id: "ProductManagement",
        title: "Product Management",
        navLink: "/product-management",
        children: [
            {
                id: "ProductsOverview",
                title: "Products Overview",
                navLink: "/product-management/overview",
            },
            {
                id: "CategoryAndSubCategories",
                title: "Category & Sub-Categories",
                navLink: "/product-management/category-and-subcategories",
            },
            {
                id: "AttributesManagement",
                title: "Attributes Management",
                navLink: "/product-management/attributes-management",
            },
            {
                id: "InventoryManagement",
                title: "Inventory Management",
                navLink: "/product-management/inventory-management",
            },
            {
                id: "ProductApprovalQueue",
                title: "Product Approval Queue",
                navLink: "/product-management/product-approval-queue",
            },
        ]
    },
    {
        id: "FBMManagement",
        title: "FBM Management",
        navLink: "/fbm-management",
    },
    {
        id: "MarketingPromotions",
        title: "Marketing & Promotions",
        navLink: "/marketing",
        children: [
            {
                id: "BannersCampaigns",
                title: "Banners Campaigns",
                navLink: "/marketing/campaigns",
            },
            {
                id: "Coupons",
                title: "Coupons",
                navLink: "/marketing/coupons",
            },
            {
                id: "Vouchers",
                title: "Vouchers",
                navLink: "/marketing/vouchers",
            },
            {
                id: "FreeDelivery",
                title: "Free Delivery",
                navLink: "/marketing/freedelivery",
            },
            {
                id: "PushNotifications",
                title: "Push Notifications",
                navLink: "/marketing/pushnotifications",
            },
            {
                id: "SellerPicks",
                title: "Seller Picks",
                navLink: "/marketing/sellerpicks",
            },
            {
                id: "SocialMediaMarketing",
                title: "Social Media Marketing",
                navLink: "/marketing/smm",
            },
        ]
    },
    {
        id: "Advertisement",
        title: "Advertisement",
        navLink: "/advertisement",
        children: [
            {
                id: "ActiveCampaigns",
                title: "Active Campaigns",
                navLink: "/advertisement/active-campaigns",
            },
        ]
    },
    {
        id: "UserManagement",
        title: "User Management",
        navLink: "/user-management",
        children: [
            {
                id: "Sellers",
                title: "Sellers",
                navLink: "/user-management/sellers",
            },
            {
                id: "Wholesalers",
                title: "Wholesalers",
                navLink: "/user-management/wholesalers",
            },
            {
                id: "Admins",
                title: "Admins",
                navLink: "/user-management/admins",
            },
            {
                id: "LoyaltyAndRewards",
                title: "Loyalty And Rewards",
                navLink: "/user-management/loyalty-and-rewards",
            },
        ]
    },
    {
        id: "BusinessManagement",
        title: "Business Management",
        navLink: "/businessmanagement",
        children: [
            {
                id: "StockMonitoring",
                title: "Stock Monitoring",
                navLink: "/businessmanagement/stockmonitoring",
            },
            {
                id: "OrderTransactions",
                title: "Order Transactions",
                navLink: "/businessmanagement/ordertransactions",
            },
            {
                id: "PurchaseHistory",
                title: "Purchase History",
                navLink: "/businessmanagement/purchasehistory",
            }
        ]
    },
    {
        id: "RefundAndDisputeManagement",
        title: "Refund & Dispute Management",
        navLink: "/refund-and-dispute-management",
        children: [
            {
                id: "RefundTransactions",
                title: "Refund Transactions",
                navLink: "/refund-and-dispute-management/refundtransactions",
            },
            {
                id: "RefundRequestList",
                title: "Refund Request List",
                navLink: "/refund-and-dispute-management/refundrequestlist",
            },
            {
                id: "RefundPoliciesAndGuidelines",
                title: "Refund Policy and Guidlines",
                navLink: "/refund-and-dispute-management/refundpolicyandguidlines",
            },
        ]
    },
    {
        id: "SupportAndCommunication",
        title: "Support & Communications",
        navLink: "/support-and-communication",
        children: [
            {
                id: "Messages",
                title: "Messages",
                navLink: "/support-and-communication/messages",
            },
            {
                id: "SupportTickets",
                title: "Support Tickets",
                navLink: "/support-and-communication/support-tickets",
            },
            {
                id: "FAQs",
                title: "FAQs",
                navLink: "/support-and-communication/FAQs",
            },
            {
                id: "FeedbackAndSuggestions",
                title: "Feedback and Suggestions",
                navLink: "/support-and-communication/feedback-and-suggestions",
            },
        ]
    },
    {
        id: "PricingFinanceAndPayment",
        title: "Pricing, Finance & Payment",
        navLink: "/pricing-finance-and-payment",
        children: [
            {
                id: "FeeAndCommissionStructure",
                title: "Fee & Commission Structure",
                navLink: "/pricing-finance-and-payment/fee-and-commission-structure",
            },
            {
                id: "Transactions",
                title: "Transactions",
                navLink: "/pricing-finance-and-payment/transactions",
            },
            {
                id: "Payouts",
                title: "Payouts",
                navLink: "/pricing-finance-and-payment/payouts",
            },
            {
                id: "PaymentMethods",
                title: "Payment Methods",
                navLink: "/pricing-finance-and-payment/payment-methods",
            },
            {
                id: "LoanManagement",
                title: "Loan Management",
                navLink: "/pricing-finance-and-payment/loan-management",
            },
        ]
    },
    {
        id: "ShippingAndDelivery",
        title: "Shipping & Delivery",
        navLink: "/shipping-and-delivery",
        children: [
            {
                id: "ShippingOptions",
                title: "Shipping Options",
                navLink: "/shipping-and-delivery/shipping-options",
            },
            {
                id: "ShippingCarriers",
                title: "Shipping Carriers",
                navLink: "/shipping-and-delivery/shipping-carriers",
            },
            {
                id: "DeliveryZones",
                title: "Delivery Zones",
                navLink: "/shipping-and-delivery/delivery-zones",
            },
            {
                id: "CarrierManagement",
                title: "Carrier Management",
                navLink: "/shipping-and-delivery/carrier-management",
            },
        ]
    },
    {
        id: "Settings&Configurations",
        title: "Settings & Configurations",
        navLink: "/settings-and-configurations",
        children: [
            {
                id: "Notifications",
                title: "Notifications",
                navLink: "/settings-and-configurations/notifications",
            },
            {
                id: "TaxSettings",
                title: "Tax Settings",
                navLink: "/settings-and-configurations/tax-settings",
            },
            {
                id: "Currency",
                title: "Currency",
                navLink: "/settings-and-configurations/currency",
            },
            {
                id: "Language",
                title: "Language",
                navLink: "/settings-and-configurations/language",
            },
        ]
    },
    {
        id: 'Web&AppManagement',
        title: 'Web & App Management',
        navLink: '/web-and-app-management',
        children: [
            {
                id: 'PageSetup',
                title: 'Page Setup',
                navLink: '/web-and-app-management/page-setup'
            },
            {
                id: 'SocialMediaLinks',
                title: 'Social Media Links',
                navLink: '/web-and-app-management/social-media-links'
            },
        ]
    },
    {
        id: 'Reports&Analytics',
        title: 'Reports & Analytics',
        navLink: '/reports-and-analytics',
        children: [
            {
                id: 'SalesReports',
                title: 'Sales Reports',
                navLink: '/reports-and-analytics/sales-reports'
            },
            {
                id: 'Customer&UserAnalytics',
                title: 'Customer & User Analytics',
                navLink: '/reports-and-analytics/customer-and-user-analytics'
            },
        ]
    },
    {
        id: 'ContentManagement',
        title: 'Content Management',
        navLink: '/content-management',
        children: [
            {
                id: 'TrainingAndResources',
                title: 'Training and Resources',
                navLink: '/content-management/training-and-resources'
            },
            {
                id: 'DocumentTemplates',
                title: 'Document Templates',
                navLink: '/content-management/document-templates'
            },
        ]
    }
];
